const styles = {
  '.slick-list': {
    position: 'relative',
    display: 'block',
    overflow: 'hidden',
    margin: '0',
    padding: '0',
    '&:focus': { outline: '0' },
  },
  '.slick-slider': {
    position: 'relative',
    display: 'block',
    boxSizing: 'border-box',
    userSelect: 'none',
    touchAction: 'pan-y',
    WebkitTapHighlightColor: 'transparent',
    '.slick-list': { transform: 'translate3d(0, 0, 0)' },
    '.slick-track': { transform: 'translate3d(0, 0, 0)' },
  },
  '.slick-track': {
    position: 'relative',
    display: 'block',
    top: '0',
    left: '0',
    '&:after': { display: 'table', content: '""', clear: 'both' },
    '&:before': { display: 'table', content: '""' },
  },
  '.slick-loading': {
    '.slick-slide': { visibility: 'hidden' },
    '.slick-track': { visibility: 'hidden' },
  },
  '.slick-list.dragging': { cursor: ['pointer', 'hand'] },
  '.slick-slide': {
    display: 'none',
    float: 'left',
    height: '100%',
    minHeight: '1px',
    padding: '1em',
    img: { display: 'block' },
  },
  '[dir="rtl"]': {
    '.slick-slide': { cssFloat: 'right' },
    '.slick-prev': {
      right: '-25px',
      left: 'auto',
      '&:before': { content: '"→"' },
    },
    '.slick-next': {
      right: 'auto',
      left: '-25px',
      '&:before': { content: '"←"' },
    },
  },
  '.slick-slide.slick-loading': { img: { display: 'none' } },
  '.slick-slide.dragging': { img: { pointerEvents: 'none' } },
  '.slick-initialized': { '.slick-slide': { display: 'block' } },
  '.slick-vertical': {
    '.slick-slide': {
      display: 'block',
      height: 'auto',
      border: '1px solid transparent',
    },
  },
  '.slick-arrow.slick-hidden': { display: 'none' },
  '.slick-dots': {
    position: 'absolute',
    display: 'block',
    padding: '0',
    bottom: '-25px',
    width: '100%',
    margin: '0',
    listStyle: 'none',
    textAlign: 'center',
    li: {
      button: {
        '&:before': {
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
          fontSize: '6px',
          lineHeight: '20px',
          position: 'absolute',
          top: '0',
          left: '0',
          width: '20px',
          height: '20px',
          content: '"•"',
          textAlign: 'center',
          opacity: 0.25,
          color: '#000',
        },
        fontSize: '0',
        lineHeight: '0',
        display: 'block',
        width: '20px',
        height: '20px',
        padding: '5px',
        cursor: 'pointer',
        color: 'transparent',
        border: '0',
        outline: '0',
        background: '0 0',
        '&:focus': { outline: '0', '&:before': { opacity: 1 } },
        '&:hover': { outline: '0', '&:before': { opacity: 1 } },
      },
      position: 'relative',
      display: 'inline-block',
      width: '20px',
      height: '20px',
      margin: '0 5px',
      padding: '0',
      cursor: 'pointer',
    },
    'li.slick-active': {
      button: { '&:before': { opacity: 0.75, color: '#000' } },
    },
  },
  '.slick-next': {
    position: 'absolute',
    display: 'block',
    padding: '0',
    fontSize: '0',
    lineHeight: '0',
    top: '50%',
    width: '20px',
    height: '20px',
    transform: 'translate(0, -50%)',
    cursor: 'pointer',
    color: 'transparent',
    border: 'none',
    outline: '0',
    background: '0 0',
    right: '-25px',
    '&:before': {
      WebkitFontSmoothing: 'antialiased',
      MozOsxFontSmoothing: 'grayscale',
      fontSize: '20px',
      lineHeight: 1,
      opacity: 0.75,
      color: '#000',
      content: '"→"',
    },
    '&:focus': {
      color: 'transparent',
      outline: '0',
      background: '0 0',
      '&:before': { opacity: 1 },
    },
    '&:hover': {
      color: 'transparent',
      outline: '0',
      background: '0 0',
      '&:before': { opacity: 1 },
    },
  },
  '.slick-prev': {
    position: 'absolute',
    display: 'block',
    padding: '0',
    fontSize: '0',
    lineHeight: '0',
    top: '50%',
    width: '20px',
    height: '20px',
    transform: 'translate(0, -50%)',
    cursor: 'pointer',
    color: 'transparent',
    border: 'none',
    outline: '0',
    background: '0 0',
    left: '-25px',
    '&:before': {
      WebkitFontSmoothing: 'antialiased',
      MozOsxFontSmoothing: 'grayscale',
      fontSize: '20px',
      lineHeight: 1,
      opacity: 0.75,
      color: '#000',
      content: '"←"',
    },
    '&:focus': {
      color: 'transparent',
      outline: '0',
      background: '0 0',
      '&:before': { opacity: 1 },
    },
    '&:hover': {
      color: 'transparent',
      outline: '0',
      background: '0 0',
      '&:before': { opacity: 1 },
    },
  },
  '.slick-next.slick-disabled': { '&:before': { opacity: 0.25 } },
  '.slick-prev.slick-disabled': { '&:before': { opacity: 0.25 } },
  '.slick-dotted.slick-slider': { marginBottom: '30px' },
};
export default styles;